export default "__VITE_ASSET__Iv$BTOUw__"